/* eslint-disable @typescript-eslint/no-explicit-any */


export const richFunctions: any = {
  purple: (chunks: string, key: string = "") => (
    <span key={`purple-${key}`} className="text-primary font-semibold">
      {chunks}
    </span>
  ),
  bold: (chunks: string, key: string = "") => <b key={`bold-${key}`}>{chunks}</b>,
  strong: (chunks: string, key: string = "") => <strong key={`strong-${key}`}>{chunks}</strong>,
  break: (chunks: string, key: string = "") => (
    <span key={`break-${key}`}>
      <br />
      {chunks}
    </span>
  ),
};

export function parseRichText(text: string, key?: string) {
  const regex = /<(\w+)>(.*?)<\/\1>/g;
  const parts = [];
  let lastIndex = 0;

  let match;
  while ((match = regex.exec(text)) !== null) {
    const [fullMatch, tag, content] = match;
    const startIndex = match.index;

    // Adiciona o texto antes da tag
    if (startIndex > lastIndex) {
      const textChunk = text.slice(lastIndex, startIndex);
      parts.push(
        ...textChunk.split("\n").map((chunk, index) =>
          index > 0 ? (
            <span key={`br-${key}-${lastIndex}-${index}`}>
              <br />
              {chunk}
            </span>
          ) : (
            chunk
          )
        )
      );
    }

    // Adiciona o componente processado
    if (richFunctions[tag]) {
      parts.push((richFunctions[tag] as any)(content, `br-${key}-${lastIndex}`));
    } else {
      parts.push(fullMatch); // Caso a tag não seja reconhecida, mantém o texto original
    }

    lastIndex = regex.lastIndex;
  }

  // Adiciona o restante do texto após a última tag
  if (lastIndex < text.length) {
    const remainingText = text.slice(lastIndex);
    parts.push(
      ...remainingText.split("\n").map((chunk, index) =>
        index > 0 ? (
          <span key={`br-${key}-${lastIndex}-${index}`}>
            <br />
            {chunk}
          </span>
        ) : (
          chunk
        )
      )
    );
  }

  return <span key={`br-${key}-${lastIndex}`}>{parts}</span>;
}
